// src/components/Common/WidgetHeader.jsx
import React from "react";
import BackButton from "./BackButton";
import HelpTooltip from "./HelpTooltip";

/**
 * By default, this is a card header (no back button).
 * Pass showBack to render the orange "← Back to Dashboard" button (page mode).
 */
export default function WidgetHeader({
  title,
  help = null,
  helpPlacement = "top",
  right = null,
  to = "/dashboard",
  showBack = false,   // ← default: hidden
  className = "",
}) {
  return (
    <div className={`flex justify-between items-center mb-6 ${className}`}>
      <div className="flex items-center gap-2 min-w-0">
        <h2 className="text-2xl font-bold truncate">{title}</h2>
        {help ? (
          <HelpTooltip
            content={help}
            placement={helpPlacement}
            className="flex-shrink-0"
          />
        ) : null}
      </div>
      <div className="flex items-center gap-2">
        {right}
        {showBack && <BackButton to={to} />}
      </div>
    </div>
  );
}
